<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TPw4Zb/tc-custom/9780253058638.jpg?1731806706840" alt="This image is the cover for the book Expulsion of Jews from Communist Poland, The Modern Jewish Experience"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Expulsion of Jews from Communist Poland, The Modern Jewish Experience
      </h1>
      <p class="bookDescription body article font2">
        <p>In March 1968, against the background of the Six-Day War, a campaign of antisemitism and anti-Zionism swept through Poland. <i>The Expulsion of Jews from Communist Poland</i> is the first full-length study of the events, their precursors, and the aftermath of this turbulent period. </p><p>Plocker offers a new framework for understanding how this antisemitic campaign was motivated by a genuine fear of Jewish influence and international power. She sheds new light on the internal dynamics of the communist regime in Poland, stressing the importance of middle-level functionaries, whose dislike and fear of Jews had an unmistakable impact on the evolution of party policy.</p><p><i>The Expulsion of Jews from Communist Poland</i> examines how Communist Party leader Wladyslaw Gomulka's anti-Zionist rhetoric spiraled out of hand and opened up a fraught Pandora's box of old assertions that Jews controlled the Communist Party, the revival of nationalist chauvinism, and a witch hunt in universities and workplaces that conjured up ugly memories of Nazi Germany.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anat Plocker
      </h2>
      
      <p class="authorDescription body article"><P>Anat Plocker teaches at the School of General Studies at Stockton University, specializing in Modern European History. Her work on communist Poland has appeared in English, Polish and Hebrew.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21a83a2a